import classNames from "classnames";

import { DComponent } from "../../../DComponent";
import Env from "../../../../environments";
import { defer } from "../../../../utils/script";
import { devLog } from "../../../../utils/log";

export default class AuthFacebook extends DComponent {
  constructor({
    parent,
    id,
    onSubmit = () => { },
    onError = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AuthFacebook"),
    });
    this.onSubmit = onSubmit;
    this.onError = onError;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AuthFacebook");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    defer(() => window.FB, () => {
      // if (!window.FB.getLoginStatus) {
      window.FB.init({
        appId: Env.DUTY_CAST_FACEBOOK_APP_ID, // App ID
        channelURL: '', // Channel File, not required so leave empty
        status: true, // check login status
        cookie: true, // enable cookies to allow the server to access the session
        oauth: true, // enable OAuth 2.0
        xfbml: false,  // parse XFBML
        version: 'v17.0',
      });
      // }
    })
  }

  show() {
    defer(() => window.FB, () => {
      window.FB.getLoginStatus((response) => { //check if user already authorized the app
        if (response.status === 'connected') {
          let accessToken = response.authResponse.accessToken;
          this.callback(accessToken);
        } else {
          window.FB.login((response) => { // opens the login dialog
            devLog(response);
            if (response.authResponse) { // check if user authorized the app
              let accessToken = response.authResponse.accessToken;
              this.callback(accessToken);
            } else {
              // user is not logged in
              if (response.status !== "unknown") {
                typeof this.onError === "function" && this.onError(response);
              }
            }
          }, { scope: 'email' }); //permission required by the app
        }
      });
    })
  }

  callback(accessToken) {
    typeof this.onSubmit === "function" && this.onSubmit(accessToken);
  }
}